import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

// Lazy — StatistikyPage pulls in Recharts (~115 KB gzip); keep it out of the
// main bundle, same as routes/vyhodnoceni.tsx.
const StatistikyPage = lazy(() =>
  import('@/modules/kontakty/StatistikyPage').then((m) => ({ default: m.StatistikyPage })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/kontakty/statistiky',
  component: () => (
    <Suspense fallback={null}>
      <StatistikyPage />
    </Suspense>
  ),
});
